import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx } from "react/jsx-runtime";
// src/components/Order.tsx
const OrderIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M7 16a1 1 0 0 0-2 0 1 1 0 1 1-2 0 3 3 0 0 1 6 0c0 .605-.264 1.07-.526 1.402-.237.301-.568.606-.767.805a1.005 1.005 0 0 1-.066.061L6.763 19H8a1 1 0 1 1 0 2H4a1 1 0 0 1-.64-1.769l2.973-2.48.155-.15.17-.168c.108-.108.185-.193.244-.267a.67.67 0 0 0 .091-.143C7.001 16.005 7 16.001 7 16Zm13 1a1 1 0 1 1 0 2h-8a1 1 0 0 1 0-2h8Zm0-6a1 1 0 1 1 0 2h-9a1 1 0 0 1 0-2h9ZM5 10V6.414l-.293.293a1 1 0 1 1-1.414-1.414l2-2A1 1 0 0 1 7 4v6a1 1 0 1 1-2 0Zm15-5a1 1 0 1 1 0 2h-9a1 1 0 0 1 0-2h9Z",
		fill: props.fill || "currentColor"
	})
}));
export { OrderIcon };
